export const EssentialIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="26"
      viewBox="0 0 21 26"
      fill="none"
    >
      <path
        d="M19.0196 15.2304C19.0196 12.8171 18.0671 10.6339 16.5243 9.05149L10.5 2.87251L4.4757 9.05149C2.93287 10.634 1.98032 12.8172 1.98031 15.2304C1.98031 20.0564 5.79468 23.9688 10.5 23.9688C15.2052 23.9688 19.0196 20.0565 19.0196 15.2304ZM15.4509 12.2987V18.1622L10.5 21.094L5.54912 18.1622V12.2987L10.5 9.36694L15.4509 12.2987ZM7.52948 13.4713V16.9895L10.5 18.7486L13.4705 16.9895V13.4713L10.5 11.7123L7.52948 13.4713ZM21 15.2304C21 21.1783 16.299 26 10.5 26C4.70094 26 0 21.1782 0 15.2304C5.2989e-06 12.2568 1.17634 9.56305 3.07534 7.61524L10.5 0L17.9247 7.61524C19.8236 9.56301 21 12.2568 21 15.2304Z"
        fill="white"
      />
    </svg>
  );
};
